import './funnelLoading.css';

/** A lightweight handoff screen; no invented percentage or timed delay. */
export function renderFunnelLoading() {
  return `<div class="funnel-loading">
    <header class="funnel-loading-brand"><img src="/assets/optimized/logo.webp" width="30" height="30" alt="" /><span>FOCUSCORP</span></header>
    <main class="funnel-loading-content" role="status" aria-live="polite" aria-busy="true">
      <div class="funnel-loading-character" aria-hidden="true">
        <div class="funnel-loading-halo"></div>
        <img src="/assets/entry-identity/guide-bob-rest.png" width="160" height="160" alt="" fetchpriority="high" />
        <div class="funnel-loading-bubble"><span></span><span></span><span></span></div>
      </div>
      <p class="funnel-loading-eyebrow">A MOMENT FOR FOCUS</p>
      <h1>Your plan,<br />coming right up.</h1>
      <p class="funnel-loading-copy">Bob is getting everything ready.</p>
      <div class="funnel-loading-track" aria-hidden="true"><span></span></div>
      <p class="funnel-loading-note">A little less scrolling. More room to build.</p>
    </main>
  </div>`;
}
